import { queryOptions } from '@tanstack/react-query';
import type { JSONContent } from '@tiptap/core';
import { documentServiceClient } from '@proposify/document-service-api-client';
import { getDocumentServiceSchemaClient } from 'services/api/client';
import { QueryKeys } from 'utils/queryKeys';
import { trackError } from '@proposify/frontend-observability';

async function fetchSnippetById(id: string): Promise<{ name: string; content: JSONContent }> {
  const response = await documentServiceClient.contentFindById(id, getDocumentServiceSchemaClient());
  const text = (response?.data as Partial<{ text: JSONContent }> | undefined)?.text;
  if (!text) {
    trackError('getSnippetById could not find snippet', {
      id,
      payload: JSON.stringify(response),
      errorFrom: 'editor-remote',
      cause: `document-service contentFindById response is empty or has no data`,
    });
    throw new Error(`Snippet with id ${id} not found`);
  }
  return { name: response.name, content: text };
}

function getById(id: string) {
  return queryOptions({
    queryKey: QueryKeys.contentLibrarySnippetById(id),
    queryFn: async () => await snippetsQueries.fetchSnippetById(id),
  });
}

export const snippetsQueries = {
  getById,
  fetchSnippetById,
};
